import React from 'react';
import moment from 'moment';
import { LabTest } from 'types/types';
import { formatArrayIntoSentence } from 'utils/utils';
import { LAB_TEST_STATUS } from 'context/visitContext';
import Modal from '../Modal';

type ModalProps = {
  onCloseModal: () => void;
  lab: LabTest;
};

function LabDetails({ onCloseModal, lab }: ModalProps) {
  const testType = formatArrayIntoSentence(lab.types.map((lap: LabTest) => lap.name));

  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-xl bg-white tablet:w-[500px]">
        <div className="flex flex-col p-8 pt-8 pb-10">
          <h3 className="text-lg font-semibold inline-flex whitespace-pre mb-4">
            Lab Report Details
          </h3>

          <div className="flex flex-col space-y-3">
            <div>
              <h3 className="font-semibold text-[15px] leading-tight">Lab Type</h3>
              <span>{testType}</span>
            </div>

            <div>
              <h3 className="font-semibold text-[15px] leading-tight">Date Requested</h3>
              <p>{moment(lab?.createdAt).format('MM/DD/YYYY')}</p>
            </div>

            <div>
              <h3 className="font-semibold text-[15px] leading-tight">Status</h3>
              <p>
                {lab.status === LAB_TEST_STATUS.REQUESTED
                  ? 'Requested'
                  : lab.status === LAB_TEST_STATUS.SENT_TO_LAB ||
                    (lab.status === LAB_TEST_STATUS.RECEIVED_REPORT && !lab.url)
                  ? 'Sent To Lab'
                  : 'Results Ready'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LabDetails;
